import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { formatPrice } from '@/lib/market/format'

interface RangeBarProps {
    low: number
    high: number
    value: number
    showLabels?: boolean
    className?: string
    label?: string
}

const RangeBar = ({ low, high, value, showLabels = false, className, label = '52-week range' }: RangeBarProps): ReactNode => {
    const span = high - low
    const position = span > 0 ? Math.min(100, Math.max(0, ((value - low) / span) * 100)) : 50

    return (
        <div className={cn('min-w-0', className)}>
            <div
                role='img'
                aria-label={`${label}: low ${formatPrice(low)}, high ${formatPrice(high)}, current ${formatPrice(value)}`}
                className='relative h-1.5 rounded-full bg-secondary'
            >
                <div
                    className='absolute inset-y-0 left-0 rounded-full bg-linear-to-r from-down/50 via-flat/40 to-up/50'
                    style={{ width: `${position}%` }}
                />

                <div
                    className='absolute top-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-card bg-foreground'
                    style={{ left: `${position}%` }}
                />
            </div>

            {showLabels && (
                <div className='mt-1.5 flex justify-between text-[11px] tabular-nums text-muted-foreground'>
                    <span>{formatPrice(low)}</span>
                    <span>{formatPrice(high)}</span>
                </div>
            )}
        </div>
    )
}

export default RangeBar
